// CSV parsing shared by the bulk-upload screens.
//
// Lifted out of Master.js so there is ONE parser. Both screens take files
// typed by the same people in the same spreadsheet, and two copies of this
// logic would drift — the quoted-newline handling below was a bug fix, and it
// should not have to be made twice.

export function parseCSV(text) {
  // Strip BOM, normalise line endings
  const clean = String(text).replace(/^﻿/, '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');

  // Scan the whole file character by character rather than splitting on
  // newlines first. A newline INSIDE a quoted cell is part of the value — which
  // is how a multi-line address or remark is written, and splitting first tore
  // those rows apart and silently skipped them. "" is an escaped quote.
  const records = [];
  let row = [], cur = '', inQ = false;
  for (let i = 0; i < clean.length; i++) {
    const ch = clean[i];
    if (inQ) {
      if (ch === '"') {
        if (clean[i + 1] === '"') { cur += '"'; i++; }   // escaped quote
        else inQ = false;
      } else cur += ch;
    } else if (ch === '"') inQ = true;
    else if (ch === ',') { row.push(cur); cur = ''; }
    else if (ch === '\n') { row.push(cur); records.push(row); row = []; cur = ''; }
    else cur += ch;
  }
  if (cur.length || row.length) { row.push(cur); records.push(row); }

  const lines = records
    .map(r => r.map(v => v.trim()))
    .filter(r => r.some(v => v.length));
  if (lines.length < 2) return { headers: [], rows: [] };

  const rawHeaders = lines[0];
  const norm = h => h.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
  const headers = rawHeaders.map(norm);
  const rows = lines.slice(1).map(vals => {
    const obj = {};
    headers.forEach((h, i) => { obj[h] = (vals[i] || '').trim(); });
    // Also key each value by the header as typed (lower-cased). Callers look up
    // either spelling — "staff name" as well as "staff_name" — and a mismatch
    // between the two silently skipped every row.
    rawHeaders.forEach((h, i) => {
      const asTyped = h.trim().toLowerCase();
      if (asTyped && !(asTyped in obj)) obj[asTyped] = (vals[i] || '').trim();
    });
    return obj;
  }).filter(r => Object.values(r).some(v => v));   // skip blank rows

  return { headers, rows };
}

export function downloadCsv(filename, content) {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
